export class HeaderContentConfig {
  label?: string;
  prop?: string;

  constructor(options = {}) {
    Object.assign(this, options);
  }
}
